import * as React from "react"
import * as styles from "../page_css/page.css"
import IconTikTok from "../graphics/icon-tiktok.svg"
import IconInstagram from "../graphics/icon-instagram.svg"
import IconFacebook from "../graphics/icon-facebook.svg"
import IconTwitter from "../graphics/icon-twitter.svg"
import IconYoutube from "../graphics/icon-youtube.svg"
import IconLink from "../graphics/icon-link.svg"
import IconVimeo from "../graphics/icon-vimeo.svg"
import IconTidal from "../graphics/icon-tidal.svg"
import IconSpotify from "../graphics/icon-spotify.svg"

export default function SocialLinks({performer}) {
    const size = {height:"32px", width:"32px"};

    return (
        <div className={styles.contributorSocial}>
            {performer.website && (<a href={performer.website} target="_blank"><IconLink style={size}/></a> )}
            {performer.facebook && (<a href={performer.facebook} target="_blank"><IconFacebook style={size}/></a> )}
            {performer.instagram && (<a href={performer.instagram} target="_blank"><IconInstagram style={size}/></a> )}
            {performer.tiktok && (<a href={performer.tiktok} target="_blank"><IconTikTok style={size}/></a> )}
            {performer.twitter && (<a href={performer.twitter} target="_blank"><IconTwitter style={size}/></a> )}
            {performer.youtube && (<a href={performer.youtube} target="_blank"><IconYoutube style={size}/></a> )}
            {performer.vimeo && (<a href={performer.vimeo} target="_blank"><IconVimeo style={size}/></a> )}
            {performer.tidal && (<a href={performer.tidal} target="_blank"><IconTidal style={size}/></a> )}
            {performer.spotify && (<a href={performer.spotify} target="_blank"><IconSpotify style={size}/></a> )}
        </div>
    )
  };